export default __webpack_public_path__ + "moon-phase-outline.png";